import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { dollars } from 'utils/money';
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { fetchApplications } from 'actions/applications';
import { fetchLoans } from 'actions/loans';
import Search from '@material-ui/icons/Search';
import Add from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import CustomIcon from 'components/Icons';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AttachMoney from '@material-ui/icons/AttachMoney';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Progress from '../Applications/Progress';
import SettlementReport from './SettlementReport';

const styles = theme => ({
  statsRoot: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    margin: '20px'
  },
  statsWrapper: {
    padding: '30px',
    minWidth: '100px',
    margin: '10px'
  },
  statsLink: { textDecoration: 'none' },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    alignItems: 'center'
  },
  appProgressWrapper: {
    padding: '30px',
    overflowX: 'auto',
    maxHeight: '300px',
    overflowY: 'scroll'
  }
});

const colNames = [
  { id: 'loanNumber', type: 'string', label: 'Settlement' },
  { id: 'createdAt', type: 'date', label: 'Settlement Date' },
  { id: 'orgName', type: 'string', label: 'Company' },
  { id: 'status', type: 'string', label: 'Status' },
  { id: 'principal', type: 'number', label: 'Principal' },
  { id: 'referralCommission', type: 'number', label: 'Commission' },
  { id: 'applicationNumber', type: 'string', label: 'Application' }
];

class List extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(
      fetchApplications({
        appType: 'referral',
        status: ['draft', 'lodged', 'approved', 'authorized', 'quoted', 'doc_requested', 'rejected', 'complete']
      })
    );
    this.props.dispatch(fetchLoans({appType: "referral"}));
  };

  renderHeading = () => {
    return (
      <div className={this.props.classes.heading}>
        <Typography variant='headline'>
          Dashboard
        </Typography>
      </div>
    );
  }

  renderStats = () => {
    const { classes, applications, leads, settlements } = this.props;
    const totalCommission = settlements.reduce((memo, obj) => memo + obj.referralCommission, 0.0);

    return (
      <div className={classes.statsRoot}>
        <Link to='/leads' className={classes.statsLink} >
          <Paper className={classes.statsWrapper}>
            <CustomIcon icon={<AssignmentIcon color='primary' />} text='Leads'/>
            <br/>
            <Typography variant='title'>
              { leads.length }
            </Typography>
          </Paper>
        </Link>
        <Link to='/applications' className={classes.statsLink} >
          <Paper className={classes.statsWrapper}>
            <CustomIcon icon={<AssignmentIndIcon color='primary' />} text='Applications'/>
            <br/>
            <Typography variant='title'>
              { applications.length }
            </Typography>
          </Paper>
        </Link>
        <Link to='/settlements' className={classes.statsLink} >
          <Paper className={classes.statsWrapper}>
            <CustomIcon icon={<CheckCircle color='primary' />} text='Settlements'/>
            <br />
            <Typography variant='title'>
              { settlements.length }
            </Typography>
          </Paper>
        </Link>
        <Link to='/settlements' className={classes.statsLink} >
          <Paper className={classes.statsWrapper}>
            <CustomIcon icon={<AttachMoney color='primary' />} text='Commission'/>
            <br />
            <Typography variant='title'>
              { dollars(totalCommission) }
            </Typography>
          </Paper>
        </Link>
      </div>
    );
  }

  renderWipApps = () => {
    const { classes, applications } = this.props

    return (
      <Paper className={classes.appProgressWrapper}>
        <Typography variant='subheading' className={this.props.classes.heading}>
          Recent Applications
        </Typography>
        { applications.slice(0, 10).map(app => <Progress key={app.number} application={app} />)}
      </Paper>
    );
  }

  render = () => {
    return (
      <div>
        { this.renderHeading() }
        <Divider light />
        { this.renderStats() }
        <Divider light />
        { this.renderWipApps() }
        { /* todo: restore settlement */ }
        { false && <SettlementReport settlements={this.props.settlements}/> }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const applications = (state.applications && state.applications.list) || [];
  const leads = applications.filter(a=>a.status === 'draft');
  const settlements = state.loans && state.loans.list || [];

  return { applications, leads, settlements };
}

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Dashboard/List.js